export default "__VITE_ASSET__1715e4d1__"